<template>
  <!-- <span>Tư vấn hội nhập</span>
  <br />
  <span>Hội người Việt Nam tại Berlin và Brandenburg e.V.</span>
  <br /> -->
  <span class="whitespace-pre-line w-full text-lg">{{ title }}</span>
  <br />
  <section class="user-pic flex justify-center">
    <!-- <img :src="imgPath" /> -->
    <!-- <img src="../assets/namanh.png" class="rounded-full mx-auto my-1" /> -->
    <div v-for="(image, index) in imagesPath" :key="index" class="m-1">
      <img
        :src="image.path"
        class="rounded-full mx-auto my-1 border-blue-500 border-2"
      />
      <span class="text-sm">{{ image.name }}</span>
    </div>
  </section>
</template>

<script>
// import useFirebaseAuth from "../hooks/firebase-auth";
import useFirestoreApi from "../hooks/firestore-api";
import { useRoute } from "vue-router";
import { ref } from "vue";
export default {
  props: {
    username: String,
    name: String,
    title: String,
  },
  setup(props) {
    // const imgPath = "../assets/nna.png";
    // const { username } = userFirebaseAuth();
    // const imgPath = `../assets/${username.value}.png`;
    // const name = "Nam Anh Nguyen";
    // const username = props.username;
    // const name = props.name;
    // const { imagesPath } = useFirebaseAuth();
    // console.log("image path", imagesPath);
    const { getPublicUserData } = useFirestoreApi();
    const route = useRoute();
    // let imagesPath = [];
    const imagesPath = ref([]);
    // console.log("route ", route.params.username);
    // if (props.username === "vdvibb") {
    //   imagesPath = [
    //     { path: "/assets/ngocanh.jpg", name: "Nguyễn Thị Ngọc Anh" },
    //     { path: "/assets/namanh.jpg", name: "Nguyễn Nam Anh" },
    //     { path: "/assets/huong.jpg", name: "Vương Thị Hương" },
    //   ];
    // } else if (props.username === "namanh") {
    //   imagesPath = [{ path: "/assets/namanh.jpg", name: "Nguyễn Nam Anh" }];
    // }
    // const userData = async getPublicUserData(props.username);
    // console.log("image ", userData);
    getPublicUserData(route.params.username).then((res) => {
      // console.log("res ", res.imagesPath);
      imagesPath.value = res.imagesPath;
    });

    return { props, imagesPath };
  },
};
</script>

<style lang="scss" scoped>
.user-pic img {
  width: 5rem;
  height: 5rem;
  object-fit: cover;
  //   margin-bottom: 2rem;
}
</style>
